import loadable from '@loadable/component';

export const OrgDashboardRecommendedCandidateDetailPageLoadable = loadable(
  () => import('./OrgDashboardRecommendedCandidateDetailPage'),
  {
    resolveComponent: (module) =>
      module.OrgDashboardRecommendedCandidateDetailPage,
  },
);
